import { render, staticRenderFns } from "./TraduccionRevision.vue?vue&type=template&id=6f3b6b32&scoped=true"
import script from "./TraduccionRevision.vue?vue&type=script&lang=js"
export * from "./TraduccionRevision.vue?vue&type=script&lang=js"
import style0 from "./TraduccionRevision.vue?vue&type=style&index=0&id=6f3b6b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b6b32",
  null
  
)

export default component.exports